import {
    CANCEL_SUBSCRIPTION,
    CARD_REPLACE,
    PAYMENT_DETAILS_FETCH,
    RENEW_SUBSCRIPTION,
    UPDATE_PAYMENT_DETAILS
} from '../constants/paymentDetailsTypes';

export function paymentDetailsFetch(params) {
  return {
    type: PAYMENT_DETAILS_FETCH,
    payload: params
  };
}

export function updatePaymentDetails(params) {
  return {
    type: UPDATE_PAYMENT_DETAILS,
    payload: params
  };
}

export function cardReplace(params) {
  return {
    type: CARD_REPLACE,
    payload: params
  };
}

export function renewSubscription() {
  return {
    type: RENEW_SUBSCRIPTION
  };
}

export function cancelSubscription() {
  return {
    type: CANCEL_SUBSCRIPTION
  };
}



// WEBPACK FOOTER //
// ./app/actions/PaymentDetailsActions.js